const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFreelancers(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.453,
    height: 16.502,
    viewBox: "0 0 19.453 16.502",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 775"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 774"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 5069",
    d: "M400 273.32h-1.5a3.913 3.913 0 0 1 .237 1.345v5.686a1.677 1.677 0 0 1-.1.562h2.487a1.687 1.687 0 0 0 1.685-1.685v-3.1A2.811 2.811 0 0 0 400 273.32z",
    transform: "translate(-383.353 -264.411)",
    style: {
      fill: "#d9d9d9"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 777"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 776"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 5070",
    d: "M4.076 274.666a3.913 3.913 0 0 1 .237-1.345h-1.5A2.811 2.811 0 0 0 0 276.129v3.1a1.687 1.687 0 0 0 1.685 1.685h2.487a1.677 1.677 0 0 1-.1-.562z",
    transform: "translate(0 -264.412)",
    style: {
      fill: "#d9d9d9"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 779"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 778"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 5071",
    d: "M143.077 234.815h-3.439a2.811 2.811 0 0 0-2.808 2.808v5.686a.562.562 0 0 0 .562.562h7.932a.562.562 0 0 0 .562-.562v-5.686a2.811 2.811 0 0 0-2.809-2.808z",
    transform: "translate(-131.63 -227.369)",
    style: {
      fill: "#d9d9d9"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 781"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 780"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 5072",
    d: "M170.491 38.84a3.377 3.377 0 1 0 3.377 3.377 3.381 3.381 0 0 0-3.377-3.377z",
    transform: "translate(-160.765 -38.84)",
    style: {
      fill: "#d9d9d9"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 783"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 782"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 5073",
    d: "M35.969 121.689a2.524 2.524 0 1 0 2.526 2.526 2.529 2.529 0 0 0-2.526-2.526z",
    transform: "translate(-32.172 -118.541)",
    style: {
      fill: "#d9d9d9"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 785"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 784"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 5074",
    d: "M348.133 121.689a2.526 2.526 0 1 0 2.526 2.526 2.529 2.529 0 0 0-2.526-2.526z",
    transform: "translate(-332.476 -118.541)",
    style: {
      fill: "#d9d9d9"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFreelancers);
export default __webpack_public_path__ + "static/media/freelancers.7a6187de49e35da39d50a04efea48196.svg";
export { ForwardRef as ReactComponent };